import { State } from 'src/types'

import { crossJointWeb, crossWeb, crossWebCenterStitch } from 'src/features/brands/yellStory/canvas/glove/front/web/crossWeb'
import { vWebWithLace } from 'src/features/brands/yellStory/canvas/glove/front/web/vWeb'
import { laceOfCrossWebWithHalfNet } from 'src/features/brands/yellStory/canvas/glove/front/web/netWeb'
import { laceOfNetWebDouble, netWebDouble } from 'src/features/brands/yellStory/canvas/glove/front/web/netWebDouble'
import { hJointWeb, hWeb } from 'src/features/brands/yellStory/canvas/glove/front/web/hWeb'
import {
  underWeb,
  underWebForNetWeb1,
  underWebForNetWeb2,
  underWebReinforcement
} from 'src/features/brands/yellStory/canvas/glove/front/lace/underWeb'
import { jointCheckerWeb } from 'src/features/brands/yellStory/canvas/glove/front/web/jointCheckerWeb'
import { indexWrapBack } from 'src/features/brands/yellStory/canvas/glove/front/lace/connectIndexToWeb'
import {
  crossWebWithHalfNetLace,
  crossWebWithHalfNetLaceAroundStitch
} from 'src/features/brands/yellStory/canvas/glove/front/web/crossWebWithHalfLaceWeb'
import { yw14Web } from './yw14Web'
import { onePeaceWeb } from './onePeaceWeb'
import { jointOnePeaceWeb } from './jointOnepeaceWeb'
import { yw17Web } from './yw17'
import { reinforcementLaceModel } from 'src/features/brands/yellStory/constants/baseModel'
import { webDrawUtil } from 'src/features/brands/util/canvas'

export const webOfGloveFrontDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor } = webDrawUtil(state)
  if (webMatcher(['Yw1', 'Yw2', 'Yw10'])) crossWebCenterStitch(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw3'])) crossWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw4'])) crossWebWithHalfNetLaceAroundStitch(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw5', 'Yw12'])) crossJointWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw6'])) hWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw7'])) hJointWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw8'])) vWebWithLace(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw9'])) jointCheckerWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw11'])) crossWebWithHalfNetLace(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw13'])) netWebDouble(ctx, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw14'])) yw14Web(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw15'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['Yw16'])) jointOnePeaceWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw17'])) yw17Web(ctx, webColor, web2Color, laceColor, stitchColor)
}

export const rightLaceOfNetWebDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, laceColor, stitchColor, productNumber } = webDrawUtil(state)
  const condCrossWebWithHalfLace = webMatcher(['Yw4', 'Yw8', 'Yw11'])
  if (condCrossWebWithHalfLace) laceOfCrossWebWithHalfNet(ctx, laceColor)
  if (webMatcher(['Yw13'])) {
    laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
    underWebForNetWeb1(ctx, laceColor, 0, 0)
    underWebForNetWeb1(ctx, laceColor, -17, 30)
    underWebForNetWeb2(ctx, laceColor, -133, 95, -20)
    underWebForNetWeb2(ctx, laceColor, -15, 28, 0)
  } else {
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, 0, 0) // 下
  }
  // 補強レース
  if (reinforcementLaceModel.includes(productNumber)) underWebReinforcement(ctx, laceColor)
}
